import { useRef } from 'react'
import styles from './index.module.scss'
import eventBus from '@utils/eventBus';
import { SELECT_ORG_TYPE } from '@utils/CONST'
import { useNavigate } from 'react-router-dom';
import Utils from '@utils/utils';
import { BATCH_IMAGES_TYPE } from '@utils/CONST';
import API from '@api/api'

const batchProductImagesBaseUrl = "https://photostudio-ai-oss.arcsoft.com.cn/photostudio-web/admin/batchProduceImages/";

const list = [{
    title: 'AI试衣 ',
    smallTitle: '上传服装图，一键生成真人上身效果',
    value: BATCH_IMAGES_TYPE.TRYON_BATCH,
}, {
    title: '换模特',
    smallTitle: '同一件衣服，秒换不同风格模特',
    value: BATCH_IMAGES_TYPE.CHANGE_MODEL_BATCH,
}, {
    title: '换背景',
    smallTitle: 'AI智能抠图，自由替换场景背景', 
    value: BATCH_IMAGES_TYPE.CHANGE_BKG_BATCH,
},
{
    title: '同款换色',
    smallTitle: '一张图生成多色系款式图 ',
    value: BATCH_IMAGES_TYPE.SIM_RECOLOR_BATCH,
}, 
{
    title: 'AI超清',
    smallTitle: '低分辨率图片一键放大增强画质',
    value: BATCH_IMAGES_TYPE.IMAGE_FINER_BATCH,
}, {
    title: '去水印',
    smallTitle: '智能擦除水印，还原干净画面',
    value: BATCH_IMAGES_TYPE.WATERMARK_REMOVE_BATCH,
}, {
    title: '搭配上身',
    smallTitle: '多件单品智能搭配，合成穿搭效果图',
    value: BATCH_IMAGES_TYPE.FUSIONWEAR_BATCH,
}, {
    title: '种草图',
    smallTitle: '种草图',
    value: BATCH_IMAGES_TYPE.GRASS_PLANT_BATCH,
}, {
    title: '图生视频',
    smallTitle: '静态商品图一键转为短视频素材',
    value: BATCH_IMAGES_TYPE.IMAGE_TO_VIDEO_BATCH,
    mediaType: 'video',
    mediaUrl: `${batchProductImagesBaseUrl}createSample_9.mp4`,
    poster: `${batchProductImagesBaseUrl}createSample_9.png`,
}, {
    title: '',
    smallTitle: '',
}]


const DefaultEmpytPage = (props) => {
    const { disabledTitle } = props
    const navigate = useNavigate()
    const videoRefMap = useRef({})

    const handleVideoHoverChange = (key, playing) => {
        const target = videoRefMap.current[key]
        if (!target) return
        if (playing) {
            target.currentTime = 0
            const playPromise = target.play()
            if (playPromise && typeof playPromise.catch === 'function') {
                playPromise.catch(() => { })
            }
            return
        }
        target.pause()
        target.currentTime = 0
    }

    const createClick = (item) => {
        const isLogin = Utils.checkLoginStatus(() => loginAfter(item))
        if (!isLogin) return
        loginAfter(item)
    }
    const loginAfter = (item) => {
        if (!item?.value) {
            return
        }
        API.getUserOrgInfo({}).then((res) => {
            if (res.code == 0) {
                const isPersonal = !res.data.current || !res.data.current?.id
                if (isPersonal) {
                    if (res?.data?.orgList?.length > 1) {
                        eventBus.emit('OPEN_SELECT_TEAM', { type: SELECT_ORG_TYPE.CHANGEORG, noPersonal: true })
                    } else eventBus.emit('OPEN_CREATE_TEAM')
                } else navigate(`/home/product/${item.value}/upload`)
            }
        })
    }

    return (
        <div className={`${styles.DefaultEmpytPage} _beauty_scrollbar`}>
            {
                (
                    <div className={`${styles.listWarpBox}`}>
                        {!disabledTitle && <img className={styles.sampleBg} src={`${batchProductImagesBaseUrl}sample_bg.png`} alt="" />}
                        {!disabledTitle && <div className={styles.listWarpTitile} />}
                        <div className={`${styles.listWarp}`}>
                            {
                                list.map((item, index) => (
                                    (() => {
                                        const hasCardInfo = !!(item.title || item.smallTitle)
                                        return (
                                    <div key={item.value}
                                        className={`${styles.listItem} ${styles[`listItem${index + 1}`]} ${!hasCardInfo ? styles.listItemNoInfo : ''}`}
                                        onClick={() => createClick(item)}>
                                        <div className={styles.mediaArea}>
                                            {
                                                item.mediaType === 'video' ?
                                                    <div
                                                        className={styles.videoWrap}
                                                        onMouseEnter={() => handleVideoHoverChange(item.value, true)}
                                                        onMouseLeave={() => handleVideoHoverChange(item.value, false)}
                                                    >
                                                        <video
                                                            ref={node => { videoRefMap.current[item.value] = node }}
                                                            className={styles.videoBox}
                                                            src={item.mediaUrl}
                                                            loop
                                                            muted
                                                            playsInline
                                                            preload="metadata"
                                                        />
                                                        <img
                                                            className={styles.videoCover}
                                                            src={item.poster}
                                                            alt=""
                                                        />
                                                    </div> :
                                                    <div className={styles.imgBox}></div>
                                            }
                                        </div>
                                        {hasCardInfo && <div className={styles.cardInfo}>
                                            <p className={styles.title}>{item.title}</p>
                                            <p className={styles.smallTitle}>{item.smallTitle}</p>
                                        </div>}
                                    </div>
                                        )
                                    })()
                                ))
                            }
                        </div>
                    </div>
                )
            }
        </div>
    )
}

export default DefaultEmpytPage
